import styled from 'styled-components'
import theme from '../../../styles/theme'

const ButtonBase = styled.button`
  box-sizing: border-box;
  text-align: center;
  user-select: none;
  width: 100%;
  line-height: 2.95rem;
  padding: 0 1.2rem;
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
  border: ${theme.borderDefault};
  color: ${theme.white};
  background-color: ${props =>
    props.secondaryColor ? theme.red : theme.green};
  cursor: pointer;
  transition: ${theme.transitionDefault};

  &:hover {
    background-color: ${props =>
    props.secondaryColor ? theme.redDark : theme.greenDark};
  }

  &:focus {
    outline: 0;
  }

  &:disabled {
    cursor: default;
    pointer-events: none;
    color: rgba(0, 0, 0, 0.26);
    box-shadow: none;
    background-color: rgba(0, 0, 0, 0.12);
  }
`

export default ButtonBase
